import { createApi } from '@reduxjs/toolkit/query/react';
import { AxiosProgressEvent } from 'axios';

import { apiSahExternalBudgets } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

interface AcoUploadResponse {
  message?: string;
}

export const acoBudgetsApi = createApi({
  reducerPath: 'acoBudgetsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahExternalBudgets }),
  tagTypes: ['aco-budgets'],
  endpoints: (builder) => ({
    acoUpload: builder.mutation<AcoUploadResponse, { formData: FormData; onProgress?: (prog: number) => void }>({
      query: ({ formData, onProgress }) => ({
        url: '/aco-upload',
        method: 'POST',
        body: formData,
        onUploadProgress: (evt: AxiosProgressEvent) => {
          if (onProgress && evt.total) {
            const percent = Math.round((evt.loaded / evt.total) * 100);
            onProgress(percent);
          }
        },
      }),
      invalidatesTags: (_result, _error) => [{ type: 'aco-budgets', id: 'LIST' }],
      transformResponse: (payload) => unwrap<AcoUploadResponse>(payload),
    }),
  }),
});

export const { useAcoUploadMutation } = acoBudgetsApi;
